import {directive} from 'vue-clickaway'
import {Loading} from 'element-ui'

/**
 * You can register global directives here and use them as a plugin in your main Vue instance
 */

const GlobalDirectives = {
  install (Vue) {
    Vue.use(Loading.directive)
    Vue.directive('click-outside', directive)
  }
}

export default GlobalDirectives
